import React from 'react';
import { useTranslation } from 'react-i18next';

const MissionStatement: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section className="page-section">
      <div className="page-container">
        <div className="mx-auto max-w-5xl bg-[#172033] p-2 shadow-[0_22px_60px_rgba(23,32,51,0.16)]">
          <div className="border border-white/20 bg-white px-6 py-10 text-center sm:px-10 lg:px-16 lg:py-16">
            <div className="mx-auto mb-7 flex h-24 w-24 items-center justify-center rounded-full border-4 border-[#f0c8cf] bg-white shadow-lg shadow-slate-200">
              <img
                src="/LOGO.png"
                alt="JAJ Logo"
                className="h-20 w-20 rounded-full object-cover"
              />
            </div>

            <p className="font-japanese mb-2 text-sm font-bold text-[#d95f75]">私たちの使命</p>
            <h1 className="text-3xl font-extrabold uppercase text-[#172033] sm:text-4xl">
              {t('mission.title', 'Mission statement')}
            </h1>

            <div className="mx-auto my-8 h-px max-w-md bg-[#d95f75]" />

            <blockquote className="mx-auto flex max-w-3xl flex-col gap-2">
              <span
                className="block text-left text-6xl font-serif leading-none text-[#f0c8cf] sm:text-7xl"
                aria-hidden="true"
              >
                &ldquo;
              </span>
              <p className="text-xl font-semibold leading-relaxed text-slate-900 sm:text-2xl lg:text-3xl">
                {t(
                  'mission.statement',
                  'The mission of the Japanese Association of Jacksonville is to build friendships, celebrate Japanese culture, and foster mutual understanding through educational, cultural, and community programs that connect people throughout Greater Jacksonville.'
                )}
              </p>
              <span
                className="block text-right text-6xl font-serif leading-none text-[#f0c8cf] sm:text-7xl"
                aria-hidden="true"
              >
                &rdquo;
              </span>
            </blockquote>

            <div className="mx-auto mt-10 h-px max-w-sm bg-slate-300" />
            <p className="mt-6 text-xs font-bold uppercase text-slate-600">
              Japanese Association of Jacksonville
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MissionStatement;
